module.exports = __webpack_public_path__ + "img/top-bg.11d7409c.png";